import React, { useState, useEffect } from "react";
import "@frameworks/web/stylesheets/components/generic/footer/footerfeedbackpop.scss";
export const FileUploadGeneric = (props) => {
    const [docUploaded, setDocUploaded] = useState(false);
    const [fileError, setFileError] = useState(false);
    const [fileTypeError, setFileTypeError] = useState(false);
    const [docFile, setDocFile] = useState("");
    useEffect(() => {
        if (props.reset) {
            resetForm();
        }
    }, [props.reset]);
    useEffect(() => {
        if (props.fileName) {
            setDocUploaded(true);
            setDocFile(props.fileName);
        }
    }, []);
    const resetForm = () => {
        setDocUploaded(false);
        setDocFile("");
        setFileError(false);
        setFileTypeError(false);
    };
    const onSelectFile = (e) => {
        uploadFile(e.target.files[0]);
    };
    const uploadFile = (file) => {
        resetForm();
        if (file) {
            var extensions = file.name.split(".");
            if (!props.fileType.find((val) => extensions[1].toLowerCase() === val)) {
                setFileTypeError(true);
                return;
            }
        }
        if (fileError)
            setFileError(false);
        setDocFile(file.name);
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setDocUploaded(true);
            props.onSubmit({
                base64Data: reader.result,
                docFile: file.name,
            });
            // resetForm();
        };
    };
    const removeUploadFile = () => {
        if (docFile) {
            setDocFile("");
            props.onSubmit({
                base64Data: "",
                docFile: "",
            });
        }
        resetForm();
    };
    const dropHandler = (e) => {
        e.preventDefault();
        if (e.dataTransfer.items) {
            for (let i = 0; i < e.dataTransfer.items.length; i++) {
                if (e.dataTransfer.items[i].kind === "file") {
                    uploadFile(e.dataTransfer.items[i].getAsFile());
                }
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        !docUploaded && (React.createElement("label", { className: "uploadWrap cursor", onDrop: dropHandler, onDragOver: (e) => e.preventDefault(), onDragEnter: (e) => e.preventDefault() },
            React.createElement("input", { type: "file", onChange: onSelectFile, className: "display-none", id: "feedBackFile", onClick: (e) => (e.target.value = "") }),
            React.createElement("div", { className: "file-upload-section-generic" },
                React.createElement("div", null,
                    React.createElement("img", { src: props.imagename })),
                React.createElement("div", null,
                    React.createElement("label", { htmlFor: "feedBackFile", className: "upload-content DMSans_16_500 mgt-10" }, props.fileuploadname))))),
        fileTypeError && (React.createElement("div", null,
            React.createElement("p", { className: "uploadError" },
                "Please upload only ",
                "." + props.fileType.join(", ."),
                " Files."))),
        docFile && (React.createElement("div", { className: "uploadSectionWrap" },
            React.createElement("div", { className: "fileNameSec" },
                React.createElement("div", { className: "uploaded-fileName" },
                    React.createElement("p", null, docFile)),
                React.createElement("div", { className: "uploaded-fileClose", onClick: removeUploadFile },
                    React.createElement("i", { className: "edel-icon-close" })))))));
};
